import React, { useState } from 'react'
import Loadable from '../../../components/loadable/Loadable'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import Label from '../../../components/label/Label'
import Button from '../../../components/button/Button'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import styles from "./MangeUsers.styles"
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeAssignPayers, changeUserStatus, checkCreateMemberAllowed, deleteMember, exportMemberUser, exportToExcelMemberUserPayers, getMemberRoles, getMembersList, reRequest } from './ManageUserSaga'
import {componentKey, setRowsPerPage, setSkip, setFilterText, setSelectedMember, setShowImportPopup, setShowUserInfoPopup, setSelectedGroupIDs, selectPayer, setShouldLoadMemberList} from "./ManageUserSlice"
import General from '../../../../libs/utility/General'
import DateUtils from '../../../../libs/utility/DateUtils'
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks"
import TextInput from '../../../components/input/textinput/TextInput'
import Popup from '../../../components/popup/Popup'
import ImportUsers from '../component/importUsers/ImportUsers'
import UserInfo from '../component/userInfo/UserInfo'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../components/button/constants'
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup'
import Icons from '../../../components/icons/Icons'
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly'
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant'
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks'
import { COMMON_EXPORTING_STATES, COMMON_EXPORTING_STATES_MESSAGE_MAP, COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import { USER_LOADING_STATES, USER_MESSAGE_MAP } from '../constant'
import { componentKey as AuthenticationComponentKey } from '../../authentication/AuthenticationSlice'
import InformationPopup from '../../../components/popup/informationpopup/InformationPopup'
import Switch from '../../../components/switch/Switch';
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'
import { useLocation } from 'react-router-dom'

function MangeUsers() {
    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const location = useLocation();

    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
    const [showInformationPopup, setShowInformationPopup] = useState(false)
    const [informationPopupBodyText, setInformationPopupBodyText] = useState("")
    const [searchString, setSearchString] = useState("")
    const [directAddUserActionFromUrl, setDirectAddUserActionFromUrl] = useState(false)
    const [queryParams, setQueryParams] = useTxSearchParams();
    const { permissions } = useUserPermissionsInfo();

    const { showUserInfoPopup, loadingState, memberData, rowsPerPage, skip, filterText, IsDesc, exportFile, totalMembers, showImportPopup, selectedMember, memberRoles, shouldLoadMemberList, isAllowMemberToCreate} = useSelector((state) => state[componentKey])
    const { signedInUser } = useSelector((state) => state[AuthenticationComponentKey])

    useEffect(()=>{
        const timeOutId = setTimeout(() => dispatch(setFilterText(searchString)), 500);
        return () => clearTimeout(timeOutId);
    }, [searchString])

    useEffect(() => {
        if (queryParams.get('action') === 'adduser') {
            setDirectAddUserActionFromUrl(true)
		}
    }, [location.search])

    const handleShowAddUserPopup = () => {
        dispatch(setSelectedMember({}))
        dispatch(setShowUserInfoPopup(true))
    }
    useEffect(() => {
        dispatch(getMemberRoles());
        dispatch(checkCreateMemberAllowed());
    }, [])

    useEffect(() => {
        if(isAllowMemberToCreate === null){
            return
        }
        if(isAllowMemberToCreate && directAddUserActionFromUrl){
            handleShowAddUserPopup({})
        }else if(isAllowMemberToCreate == false && directAddUserActionFromUrl){
            handleShowUserAddNotAllowedPopup();
        }
    }, [isAllowMemberToCreate, directAddUserActionFromUrl])

    useEffect(() => {
        if(shouldLoadMemberList){
            handleGetMemberList(skip, rowsPerPage);
            dispatch(setShouldLoadMemberList(false));
        }
    }, [shouldLoadMemberList])

    const handleGetMemberList = (paginationSkip, paginationRows) => {
        dispatch(getMembersList({
            rowsPerPage: paginationRows,
            skip: paginationSkip,
            IsDesc: IsDesc,
            filterText: filterText,
            selectedMember: selectedMember,
        }))
    }

    useEffect(()=>{
        General.downloadFileWithBase64AndName(exportFile)
    }, [exportFile])

    useEffect(()=>{
        handleGetMemberList(skip, rowsPerPage);
    }, [rowsPerPage, skip])

    useEffect(()=>{
        handleGetMemberList(0, rowsPerPage);
        dispatch(setSkip(0))
    }, [filterText])

    const handleUserStatus = (row) => {
        dispatch(changeUserStatus({MemberId: row.UserId, IsEnabled: !row.Enabled}))
    }

    const handleAssignPayers = (row) => {
        dispatch(changeAssignPayers({MemberId: row.UserId, IsEnabled: !row.AssignAllPayers}))
    }

    const handleUserDelete = (row) => {
        dispatch(deleteMember({MemberId: selectedMember.UserId}))
        setShowConfirmationPopup(false)
        dispatch(setSelectedMember({}))
    }

    const handleUserEdit = (row) => {
        if(row.UserId === signedInUser.UserId) {
            setShowInformationPopup(true)
            setInformationPopupBodyText("You cannot update your details")
        } else {
            dispatch(setSelectedMember(row))
            dispatch(setShowUserInfoPopup(true))
        }
    }
    const handleDelete = (row) => {
        dispatch(setSelectedMember(row))
        setShowConfirmationPopup(true)
    }
    const handleReRequest = (row) => {
        dispatch(reRequest(row.Email))
    }

    const MEMBER_MANAGEMENT_COLUMNS = [
        {
            field: "memberName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Username</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FirstName}</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => 
            row.HasAccepted && <Switch isOn={ row.Enabled } handleToggleCb={ () => handleUserStatus(row)} switchUniqueId={`userActive-${row.UserId}`} title={ row.Enabled ? "Deactivate User" : "Activate User" }  />
        },
        {
            field: "userType",
            header: <Label weight={LABEL_WEIGHT[700]}>User Type</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{memberRoles.find(role => role.value === row.Role || role.label === row.Role )?.label}</span>
        },
        {
            field: "lastLogin",
            header: <Label weight={LABEL_WEIGHT[700]}>Last Login</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.LastLogin === "Not Available" ? "Not Available" : DateUtils.dateFormatter(row.LastLogin) }</span>
        },
        {
            field: "lastIP",
            header: <Label weight={LABEL_WEIGHT[700]}>Last IP Address</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.LastIP}</span>
        },
        {
            field: "accepted",
            header: <Label weight={LABEL_WEIGHT[700]}>Accepted</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.HasAccepted ? "Yes" : "No"}</span>
        },
        {
            field: "assignExistingandFuturePayers",
            header: <Label weight={LABEL_WEIGHT[700]}>Assign All Payers for Existing and Future Records</Label>,
            renderLogic: (row, idx) => 
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => { handleAssignPayers(row)}}> {row.AssignAllPayers ? "Disable" : "Enable"}</Button>
        },
        {
            field: "actions",
            header: <Label weight={LABEL_WEIGHT[700]}>Actions</Label>,
            renderLogic: (row, idx) => <div style={styles.actionButtons}>
                    <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.EDIT_USER}>
                        <Button title="Edit" type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => { handleUserEdit(row) }}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON}/></Button>
                    </ShowForAllowedPermissionsOnly>
                    <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.DELETE_USER}>
                        <Button title="Delete" type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => { handleDelete(row)}}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON}/></Button>
                    </ShowForAllowedPermissionsOnly>
                    {!row.HasAccepted ? <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => { handleReRequest(row)}}>Re-request</Button> : null}    
            </div>
        },
    ];

    const handleInputChange = (e) => {
        setSearchString(e.target.value);
    }

    const handleExportToExcel = () => {
        dispatch(exportMemberUser());
    }
    const handleExportMemberUserPayer = () => {
        dispatch(exportToExcelMemberUserPayers());
    }

    const handleShowUserAddNotAllowedPopup = () => {
        setShowInformationPopup(true)
        setInformationPopupBodyText("To create a new member, first you will have to define rights for all the roles. Please visit rights management for it.")
    }

    const handleUserInfoCancel = () => {
		dispatch(setSelectedMember({}))
		dispatch(setSelectedGroupIDs([]))
		dispatch(selectPayer([]))
		dispatch(setShowUserInfoPopup(false))
        queryParams.delete('action');
		setQueryParams(queryParams);
	}

    const handleAddUser = () => {
        if(isAllowMemberToCreate){
            queryParams.set('action', "adduser");
            setQueryParams(queryParams);
            handleShowAddUserPopup({})
        }else{
            handleShowUserAddNotAllowedPopup();
        }
    }

    const handleImportUser = () => {
        if(isAllowMemberToCreate){
            dispatch(setShowImportPopup(true))
        }else{
            handleShowUserAddNotAllowedPopup();
        }
    }

    useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.VIEW_USER, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])

  return (
    <>
            <Heading type={HEADING.H1}>Member Management</Heading>
            <Loadable currentState={loadingState.state} loadingStates={[USER_LOADING_STATES.GRID_LOADING, USER_LOADING_STATES.EXPORT_LOADING, USER_LOADING_STATES.ACTIONS_LOADING, USER_LOADING_STATES.ASSIGN_PAYER_LOADING, USER_LOADING_STATES.STATUS_LOADING]} messageMap={USER_MESSAGE_MAP} isNewLoadable={true}>
                <div style={styles.mainContainer}>

                    <div style={styles.actionsRow}>
                        <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_USER}>
                            <Button style={styles.buttonPadding} onClickCb={ handleAddUser }>Add User</Button>
                            <Button style={styles.buttonPadding} onClickCb={handleImportUser}>Import Users</Button>
                        </ShowForAllowedPermissionsOnly>
                        <Button style={styles.buttonPadding} onClickCb={() => {navigate('/users/rightsmanagement') }}>Group Rights</Button>
                        <Button style={styles.buttonPadding} onClickCb={handleExportToExcel}>Export to Excel</Button>
                        <Button style={styles.buttonPadding} onClickCb={handleExportMemberUserPayer}>Member User Payers</Button>
                    </div>
                    <div style={styles.search}>
                        <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, whiteSpace: 'pre' }}>Search </Label>
                        <TextInput 
                            type={'text'}
                            placeHolder={"Search here"} 
                            name={'search'} 
                            value={searchString} 
                            onChangeCb={(e) => handleInputChange(e)} 
                        />
                    </div>
                    
                </div>
                <div style={styles.tableBorderTop}>
                    <RichGrid
                        data={memberData}
                        columns={MEMBER_MANAGEMENT_COLUMNS}
                        selectable={false}
                        extractRowKey={(row) => row.UserId}
                        paginationProps={{
                            skip: skip,
                            take: rowsPerPage,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setRowsPerPage(newTake));
                                dispatch(setSkip(0))
                            },
                            total: totalMembers,
                            onChange: (take, t) => {
                                dispatch(setRowsPerPage(take));
                                dispatch(setSkip(t))
                            },
                        }}
                    />
                    
                </div>
            </Loadable>
            <ConfirmationPopup
                title={"Please Note"}
                bodyText={"This would delete the member user. Would you like to proceed? "}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showConfirmationPopup}
                confirmationButtonProps={{
                    onConfirmationCb: () => handleUserDelete(),
                    confirmationButtonText: "Confirm",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => setShowConfirmationPopup(false),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                showClose={false}
            />
            <InformationPopup
                title={"Please Note"}
                bodyText={informationPopupBodyText}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showInformationPopup}
                confirmationButtonProps={{
                    onConfirmationCb: () => setShowInformationPopup(false),
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                showClose={false}
            />
            <Popup title={"Import User"} onCloseCb={()=>{dispatch(setShowImportPopup(false))}} isPopupOpen={showImportPopup} customPopupSyles={styles.importUserPopupCustom} childrenStyles={styles.importUserPopupChildren}>
                <ImportUsers />
            </Popup>

            <Popup title={""} onCloseCb={ handleUserInfoCancel } isPopupOpen={showUserInfoPopup} customPopupSyles={styles.userInfoPopupCustom} overlayStyles={styles.userInfoPopupOverlay} childrenStyles={styles.userInfoPopupChildren}>
                <Loadable currentState={loadingState.state} loadingStates={[USER_LOADING_STATES.GENERAL_LOADING]} messageMap={USER_MESSAGE_MAP} isNewLoadable={true} preserveChildMount={true}>
                    { showUserInfoPopup && <UserInfo onCloseCb={ handleUserInfoCancel }/> }
                </Loadable>
            </Popup>
    </>
  )
}

export default MangeUsers